import { FC, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, firestore } from "../firebase";
import "../styles/Task.css"

export interface TaskProps {
    taskName: string,
    taskId: string,
    isCompleted: boolean,
    index: number
}
 
const Task: FC<TaskProps> = ({taskId, taskName, isCompleted, index}) => {
    const [taskComplete, setTaskComplete] = useState(isCompleted)

    const [user] = useAuthState(auth)

    const removeTask = () => {
        if(user) {
            if(window.confirm("Are you sure you want to remove this task?")) {
                const taskRef = firestore.collection(`${user.uid}`).doc(taskId)
                taskRef.delete()
            }
        }
        else {
            const savedTasks:any[] = JSON.parse(localStorage.getItem("savedTasks") || "[]")
            if(window.confirm("Are you sure you want to remove this task?")) {
                savedTasks.splice(savedTasks.indexOf(index))
                console.log(savedTasks)
                localStorage.setItem("savedTasks", JSON.stringify(savedTasks))
            }
        }
    }

    return (
        <div className="task">
            {taskComplete ? <h3 className="task-header-complete task-header">{taskName}</h3> : <h3 className="task-header-incomplete task-header">{taskName}</h3> }
            {taskComplete ? <button onClick={() => setTaskComplete(!taskComplete)}>Set as incomplete</button> : <button onClick={() => setTaskComplete(!taskComplete)}>Set as complete</button> }
            <button className="remove-task" onClick={removeTask}>Remove Task</button>
        </div>
    );
}
 
export default Task;